import sectionProductReviews03Css from '../css-snippets/section-product-reviews-03';

const html = `
<style>${sectionProductReviews03Css}</style>
<div
  class="product-reviews-wrapper product-reviews-wrapper-unique-id"
  data-id="unique-id"
  data-attribute="product-reviews-container"
  style="background-color: transparent"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <div
      class="review-overview"
      data-attribute="review-overview"
    >
      <div class="review-header" data-attribute="review-title">
        <h2 style="text-align: center">
          <strong>See What Airmoto Customers Are Saying</strong>
        </h2>
        <p style="text-align: center">
          Over 1.5 Million Units Sold and Over 25,545+ Customer Reviews
        </p>
      </div>
    </div>

    <div class="reviews-list">
      <div class="reviews-container"></div>
    </div>
  </div>
</div>

<div
  onclick="window.closeImageModal()"
  class="modal-preview-image"
  style="display: none"
>
  <div onclick="event.stopPropagation()" class="modal-preview-image-content">
    <img loading="lazy" data-attribute="modal-preview-image" src="" alt="" />
    <button
      type="button"
      class="close-modal-preview-image"
      data-attribute="close-modal-preview-image"
      onclick="window.closeImageModal()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M18 6 6 18"></path>
        <path d="m6 6 12 12"></path>
      </svg>
    </button>
  </div>
</div>

`;
export default html;
